import { StageStatus } from './Opportunities.types'

export const getOpportunityStageVariant = (opportunityStage: string) => {
  return opportunityStage === StageStatus.CLOSED_WON
    ? 'success'
    : opportunityStage === StageStatus.CLOSED_LOST
    ? 'error'
    : 'pending'
}
